'use client'

import 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart as ChartJS, ArcElement, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Legend, ChartDataLabels);

export default function EvaluationCriteriaChart(props: any) {
    return (
        <Doughnut {...props} options={{
            aspectRatio: 2 / 1,
            plugins: {
                legend: {
                    display: false,
                },
                tooltip: {
                    enabled: false
                },
                datalabels: {
                    formatter: (value, context) => {
                        if (context.chart.data.labels) {
                            return context.chart.data.labels[context.dataIndex] + '\n' + value + '%'
                        }
                    },
                    textAlign: 'center',
                    color: 'white',
                    textShadowColor: 'black',
                    textShadowBlur: 4,
                    font: {
                        size: 16,
                        weight: 'bolder',
                    }
                }
            }
        }}
            data={{
                labels: ['在學成績', '個人簡報內容', '簡報呈現方式'],
                datasets: [{
                    data: [40, 40, 20],
                    backgroundColor: [
                        '#2563fd',
                        '#ffb10a',
                        '#58C1D5'
                    ],
                    borderWidth: 0
                }]
            }}></Doughnut>
    )
}